import { ShapeProps } from '../../../../Interface/chart-v3/chart-properties.interface';
import ChartShapeProperty from '../../chart-shape-property';
import { NullableDeep } from '../../chart-shape-property.interface';
import { IDataItemProperty } from '../data-item/data-item.interface';
import { ISeriesProperty } from '../series/series.interface';
import { IGeometryProperty } from './geometry.interface';

export class GeometryProperty extends ChartShapeProperty implements IGeometryProperty {
    private parentProperty: ISeriesProperty | IDataItemProperty;
    public init(parentProperty: ISeriesProperty | IDataItemProperty) {
        this.parentProperty = parentProperty;
        return this;
    }

    public updateProps(updateProps: Partial<ShapeProps>, removeProps?: Partial<NullableDeep<ShapeProps>>): void {
        this.parentProperty.updateGeometry(updateProps, removeProps);
    }

    public getParentProperty() {
        return this.parentProperty;
    }
}
